import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BaseSiteLayoutModule } from '@lib/util';
import { IimCardModule, IimSpinnerModule } from '@iim-angular/components';
import { CompanyAddressModule } from '@lib/address';
import { IimArticleModule } from '@lib/article';
import { SupplierSelectionModule } from '@lib/supplier';
import { MatDialogModule } from '@angular/material/dialog';
import { PersonModule } from '@lib/user';
import { MatButtonModule } from '@angular/material/button';
import { WorkflowRfqModule } from './workflow/workflow-rfq.module';
import { RFQ_ROUTES } from './rfq.routes';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        BaseSiteLayoutModule,
        IimCardModule,
        CompanyAddressModule,
        IimSpinnerModule,
        IimArticleModule,
        SupplierSelectionModule,
        MatDialogModule,
        PersonModule,
        MatButtonModule,
        WorkflowRfqModule,
        RouterModule.forChild(RFQ_ROUTES),
    ],
    declarations: [],
})
export class RfqModule {}
